/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorCheckItemDto } from '../../models/vendor-check-item-dto';

export interface AsControllerGetClientVisibleCheckItems$Params {
  clientWorkspaceId: string;
  symptomId: string;
}

export function asControllerGetClientVisibleCheckItems(http: HttpClient, rootUrl: string, params: AsControllerGetClientVisibleCheckItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorCheckItemDto>>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetClientVisibleCheckItems.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('symptomId', params.symptomId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorCheckItemDto>>;
    })
  );
}

asControllerGetClientVisibleCheckItems.PATH = '/api/v1/as/client/{clientWorkspaceId}/symptoms/{symptomId}/check-items';
